import { assignInlineVars } from '@vanilla-extract/dynamic';
import { variants, textColorVar, textStyle } from './styles.css.js';
import { sprinkles } from '../sprinkles.css.js';
import { jsx } from 'react/jsx-runtime';
import { theme } from '../theme/index.css.js';

const TextBase = ({
  className = "",
  props = {},
  children,
  variantKey,
  color,
  align,
  container,
  tag = "span"
}) => {
  const Container = container ?? tag;

  if (process.env.NODE_ENV !== "production" && !(variantKey in variants)) {
    console.error(`You have used non-exist variant key ${variantKey}.`);
  }

  const variantClass = variants[variantKey] ?? "";
  const colorCssVar = color && theme.colors[color] ? assignInlineVars({
    [textColorVar]: theme.colors[color]
  }) : assignInlineVars({
    [textColorVar]: theme.colors["neutral-primary-contents"]
  });
  return /*#__PURE__*/jsx(Container, {
    className: `${variantClass} ${align ? sprinkles({
      textAlign: align
    }) : ""} ${textStyle} ${className}`,
    style: colorCssVar,
    ...props,
    children: children
  });
};
/**
 * variantKey를 직접 넘길 수 있는 형태의 Text 베이스 컴포넌트
 */


const TextVariant = ({
  variantKey,
  ...props
}) => {
  return /*#__PURE__*/jsx(TextBase, {
    variantKey: variantKey,
    ...props
  });
};
/**
 * Body, Headline, Caption의 기초가 되는 컴포넌트
 */


const Text = ({
  variant,
  size,
  weight,
  ...props
}) => {
  const variantKey = `${variant}-${size}-${weight}`;
  return /*#__PURE__*/jsx(TextVariant, {
    variantKey: variantKey,
    ...props
  });
};

Text.displayName = "Text";

const TextBody = ({
  weight = "regular",
  size = "sm",
  ...props
}) => /*#__PURE__*/jsx(Text, {
  weight: weight,
  size: size,
  ...props,
  variant: "body"
});

const TextHeadline = ({
  size = "sm",
  weight = "bold",
  tag = "h3",
  ...props
}) => /*#__PURE__*/jsx(Text, {
  weight: weight,
  size: size,
  tag: tag,
  ...props,
  variant: "headline"
});

const TextCaption = ({
  weight = "regular",
  ...props
}) => /*#__PURE__*/jsx(Text, {
  weight: weight,
  ...props,
  variant: "caption",
  size: "xs"
});

Text.Body = TextBody;
Text.Headline = TextHeadline;
Text.Caption = TextCaption;
export { Text, TextBody, TextCaption, TextHeadline, TextVariant };
